<template>
  <div class="c-home">
    <v-row>
      <v-col>
        <overview></overview>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="auto">
        <v-btn
          class="mx-1"
          outlined
          @click="exportOverview"
          v-if="hasRole('admin')"
        >
          Overview Général
          <v-icon right>save_alt</v-icon>
        </v-btn>

        <v-btn
          class="mx-1"
          outlined
          @click="exportOverviewWine"
        >
          Overview Vins
          <v-icon right>save_alt</v-icon>
        </v-btn>

        <v-btn
          class="mx-1"
          outlined
          @click="exportOverviewMachine"
          v-if="hasRole(['admin','client'])"
        >
          Overview Machines
          <v-icon right>save_alt</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col xs12 hidden-xs-only>
        <div class="section-box">
          <div class="section-text">La consommation des vins en détail</div>
        </div>

        <period-navigator>
          <wines-consumption-chart class="c-home__stats"
            :chartData="history"
            :options="{responsive: true, maintainAspectRatio: false, title: {display: false}}"
            :xLabel="xLabel"
            :styles="{height: '300px', position: 'relative'}"
          ></wines-consumption-chart>
        </period-navigator>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <div class="section-box">
          <div class="section-text">Les meilleures performances</div>
        </div>

        <wall-of-fame
        ></wall-of-fame>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import ExportAPI from '@/api/export';

import WinesConsumptionChart from '@/components/WinesConsumptionChart';
import Overview from '@/components/Overview';
import PeriodNavigator from '@/components/PeriodNavigator';
import WallOfFame from '@/components/WallOfFame';

import { periodToChartLabel, dateTimeToChartLabel } from '@/filters';

import CSVExport from '@/mixins/CSVExport';
import PeriodListener from '@/mixins/PeriodListener';
import RoleFiltering from '@/mixins/RoleFiltering';

import { STATS_GET_HISTORY } from '@/store/actions/stats';


const DEFAULT_CHART_DATA = {
  labels: [],
  datasets: [
    {
      label: 'Global',
      borderColor: '#7addff',
      fill: false,
      type: 'line'
    },
    {
      label: 'Vin rouge',
      backgroundColor: '#dd2222'
    },
    {
      label: 'Vin rosé',
      backgroundColor: '#f87979'
    },
    {
      label: 'Vin blanc',
      backgroundColor: '#fcffc6'
    }
  ]
};

export default {
  name: 'Home',

  mixins: [
    CSVExport,
    PeriodListener,
    RoleFiltering
  ],

  components: {
    Overview,
    PeriodNavigator,
    WallOfFame,
    WinesConsumptionChart
  },

  data: () => ({
    loading: false
  }),

  computed: {
    ...mapState({
      history: state => {
        const labels = [];
        const global = [];
        const red = [];
        const rose = [];
        const white = [];

        for (const d of state.stats.history) {
          labels.push(dateTimeToChartLabel(d.date, state.stats.period));
          global.push(d.volume / 100);
          red.push(d.red_volume / 100);
          rose.push(d.rose_volume / 100);
          white.push(d.white_volume / 100);
        }

        const data = Object.assign({}, DEFAULT_CHART_DATA);
        data.labels = labels;
        data.datasets[0].data = global;
        data.datasets[1].data = red;
        data.datasets[2].data = rose;
        data.datasets[3].data = white;

        return data;
      },
      xLabel: state => {
        return periodToChartLabel(state.stats.period);
      }
    })
  },

  mounted () {
    this.fetchData();
  },

  methods: {
    fetchData () {
      this.loading = true;

      this.$store.dispatch(STATS_GET_HISTORY)
        .finally(() => {
          this.loading = false;
        });
    },

    exportOverview () {
      this.saveCSV(ExportAPI.getOverview(
        this.period,
        this.period_from,
        this.period_to
      ), 'export_overview_general');
    },

    exportOverviewWine () {
      this.saveCSV(ExportAPI.getOverviewWine(
        this.period,
        this.period_from,
        this.period_to
      ), 'export_overview_wine');
    },

    exportOverviewMachine () {
      this.saveCSV(ExportAPI.getOverviewMachine(
        this.period,
        this.period_from,
        this.period_to
      ), 'export_overview_machine');
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
